function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.514 5.276H8.42V1.183c0-1.578-2.448-1.578-2.448 0v4.093H1.881c-1.578 0-1.578 2.448 0 2.448h4.092v4.093c0 1.578 2.448 1.578 2.448 0V7.724h4.093c1.578 0 1.578-2.448 0-2.448z"
});

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPlus;